
import {
  Component,
  Inject,
  InjectReactive,
  Vue,
  Watch
} from "vue-property-decorator";
import AdminTable from "@/components/admin/AdminTable.vue";
import { ADMIN_PROFILE_SYMBOL, SELL_SERVER_URL_SYMBOL } from "@/constants";
import * as _ from "lodash";
import SkinsplusItem from "@/components/buy/SkinsplusItem.vue";
import CircleLoading from "@/components/loading/CircleLoading.vue";

@Component({
  components: {
    AdminTable,
    CircleLoading,
    SkinsplusItem
  }
})
export default class AdminUsers extends Vue {
  @InjectReactive(SELL_SERVER_URL_SYMBOL) sellServerUrl!: string;
  @InjectReactive(ADMIN_PROFILE_SYMBOL) public admin: any | null;
  showPartnerInventory = false;
  selected: any[] = [];
  partnerOnly = false;
  partnerInventoryPage = 1;
  partnerInventoryPagesCount = 1;
  partnerInventoryItemsPerPage = 100;

  _columns() {
    let columnResult: Record<string, any>[];
    columnResult = this.columns;

    if (this.admin.role === "ASSISTANT") {
      columnResult = columnResult.filter(v => {
        return ["_id", "name", "partner"].includes(v.field);
      });
    }

    return columnResult;
  }

  columns = [
    {
      name: "_id",
      required: true,
      label: "ID",
      field: "_id",
      align: "left",
      type: "string"
    },
    {
      name: "providerId",
      required: true,
      label: "Provider ID",
      field: "providerId",
      align: "left",
      type: "string"
    },
    {
      name: "name",
      align: "center",
      label: "name",
      field: "name",
      editable: true,
      type: "string"
    },
    {
      name: "partner",
      align: "center",
      label: "partner",
      field: "partner",
      editable: true,
      type: "boolean"
    },

    {
      name: "partnerResultUrl",
      align: "center",
      label: "partnerResultUrl",
      field: "partnerResultUrl",
      editable: true,
      type: "string"
    },
    {
      name: "password",
      align: "center",
      label: "password",
      field: "password",
      editable: true,
      type: "string"
    },
    {
      name: "partnerRedirectUrl",
      align: "center",
      label: "partnerRedirectUrl",
      field: "partnerRedirectUrl",
      editable: true,
      type: "string"
    },
    {
      name: "partnerMinDeposit",
      align: "center",
      label: "partnerMinDeposit",
      field: "partnerMinDeposit",
      editable: true,
      type: "number"
    },
    {
      name: "partnerSteamItemCommission",
      align: "center",
      label: "partnerSteamItemCommission",
      field: "partnerSteamItemCommission",
      editable: true,
      type: "object"
    },
    {
      name: "partnerWithdrawSteamItemCommission",
      align: "center",
      label: "partnerWithdrawSteamItemCommission",
      field: "partnerWithdrawSteamItemCommission",
      editable: true,
      type: "object"
    },
    {
      name: "partnerApiKey",
      align: "center",
      label: "partnerApiKey",
      field: "partnerApiKey",
      editable: true,
      type: "string"
    },
    {
      name: "partnerSteamBotMaxItemsPrice",
      align: "center",
      label: "partnerSteamBotMaxItemsPrice",
      field: "partnerSteamBotMaxItemsPrice",
      editable: true,
      type: "number"
    },
    {
      name: "balance",
      align: "center",
      label: "balance",
      field: "balance",
      editable: true,
      type: "number"
    }
  ];
  getPartnerSteamBotItems: any = [];
  filterGetPartnerSteamBotItems: any = "";
  getPartnerSteamBotItemsLoading = false;
  abortController = new AbortController();

  sumBy(args, key) {
    return _.sumBy(args, key);
  }

  @Watch("showPartnerInventory")
  async onGetPartnerSteamBotItemsResult(v: boolean) {
    if (!v) {
      this.getPartnerSteamBotItems = [];
      return this.abortController.abort();
    }

    this.abortController = new AbortController();
    this.getPartnerSteamBotItemsLoading = true;

    let items: any[] = [];
    const limit = 50000;
    let cursor = "";

    while (true) {
      const _items = await fetch(
        this.sellServerUrl +
          `api/partner/items/v2?limit=${limit}&cursor=${cursor}`,
        {
          method: "GET",

          headers: new Headers({
            Authorization: this.lastSelected.partnerApiKey
          }),
          signal: this.abortController.signal
        }
      ).then(response => response.json());

      if (!Array.isArray(_items) || !_items.length) {
        break;
      }

      items = items.concat(_items);

      cursor = _items[_items.length - 1].id;
    }

    this.getPartnerSteamBotItemsLoading = false;
    items.sort((a, b) => b.price - a.price);
    this.getPartnerSteamBotItems = items;
    this.partnerInventoryPagesCount = items.length
      ? Math.ceil(items.length / this.partnerInventoryItemsPerPage)
      : 1;
  }

  get filteredGetPartnerSteamBotItems() {
    let result: any[] = [];

    for (
      let i =
        (this.partnerInventoryPage - 1) * this.partnerInventoryItemsPerPage;
      i < this.partnerInventoryPage * this.partnerInventoryItemsPerPage;
      i++
    ) {
      const item = this.getPartnerSteamBotItems[i];

      if (!item) {
        break;
      }

      if (
        this.filterGetPartnerSteamBotItems &&
        item.name
          .toLowerCase()
          .indexOf(this.filterGetPartnerSteamBotItems.toLowerCase()) === -1
      ) {
        continue;
      }

      result.push(item);
    }

    return result;
  }

  get lastSelected() {
    return _.last(this.selected) || null;
  }
}
